import { useParams, useSearchParams } from "react-router-dom";
import { editReport, getReport } from "../../api/reportAPI";
import { useEffect, useState } from "react";
import { useNotification } from "../../hooks/useNotification";
import { ReportCreate, ReportData } from "../../types/api/report";
import CustomSnackbar from "../../components/UI/CustomSnackbar";
import { FormProvider, useForm } from "react-hook-form";
import { ReportSelector } from "../../components/forms/ReportForm/ui/ReportSelector";
import { Box, Button, Paper, Stack } from "@mui/material";
import Loader from "../../components/Loader/Loader";
import { ReportTypes } from "../../constants/reportTypes";
import { getFormFieldsWithValues } from "../../utils/getChangedFormFields";

export const ReportScheduleEditPage = () => {
    const isOwner =
        localStorage.getItem("employee_type") == "16" &&
        localStorage.getItem("employee_center_id") == localStorage.getItem("current_center_id");

    const { id, reportId } = useParams();
    const [search] = useSearchParams();
    const reportDateId = search.get("report_date_id");
    const reportType = Number(search.get("report_type")) as unknown as ReportTypes;
    const { setNotification, setOpenSnackbar, notification, openSnackbar } = useNotification();

    const [load, setLoad] = useState(false);

    const editForm = useForm<ReportCreate>();

    const editResetFormData = (data: ReportData) => {
        editForm.reset({
            report_date_id: Number(data?.report_date_id),
            // беда с башкой тут. прилетает массив с null, но редачит и оправлять данные надо как обьект
            info: Array.isArray(data?.info) ? {} : data?.info,
        });
    };

    const edit = (data: any) => {
        const { document_id, ...innerData } = data;
        const preparedData = getFormFieldsWithValues(innerData);
        setLoad(true);
        editReport(
            Number(id),
            Number(reportId),
            { ...preparedData, report_date_id: Number(reportDateId), ...(document_id ? { document_id } : {}) },
            ({ data }) => {
                editResetFormData(data);
                getReportData(Number(reportId));
                setNotification({
                    severity: "success",
                    message: "Отчет изменен успешно",
                });
                setOpenSnackbar(true);
                setLoad(false);
            },
            err => {
                setNotification({
                    severity: "error",
                    message: err.message || "",
                });
                setLoad(false);
                setOpenSnackbar(true);
                if (err?.errors) {
                    Object.keys(err.errors).forEach((fieldName: any) => {
                        editForm.setError(fieldName, {
                            type: "custom",
                            message: err.errors[fieldName][0],
                        });
                    });
                }
            },
        );
    };

    const getReportData = (reportId: number) => {
        setLoad(true);
        getReport(
            Number(id),
            Number(reportId),
            ({ data }) => {
                editResetFormData(data);
                setLoad(false);
            },
            err => {
                setLoad(false);
                setNotification({
                    severity: "error",
                    message: err.message || "",
                });
            },
        );
    };

    useEffect(() => {
        if (id && reportId) {
            getReportData(Number(reportId));
        }
    }, [id, reportId]);

    return (
        <>
            <div className={"container"}>
                <div className={"pageHeader"}>Редактирование</div>
                {!load && (
                    <Box
                        component="form"
                        sx={{
                            "& .MuiTextField-root": { my: 1 },
                        }}
                        noValidate
                        onSubmit={editForm.handleSubmit(edit)}
                        autoComplete="off">
                        <Paper sx={{ p: 1 }}>
                            <Stack direction={"column"} gap={1}>
                                <FormProvider {...editForm}>
                                    <ReportSelector
                                        type={reportType}
                                        editForm
                                        centerId={Number(id)}
                                        reportId={Number(reportId)}
                                    />
                                    {isOwner && (
                                        <Stack direction="row" gap="row" justifyContent={"flex-end"}>
                                            <div className={"btnContainer"}>
                                                <Button type="submit">Сохранить</Button>
                                            </div>
                                        </Stack>
                                    )}
                                </FormProvider>
                            </Stack>
                        </Paper>
                    </Box>
                )}
            </div>
            <CustomSnackbar openSnackbar={openSnackbar} setOpenSnackbar={setOpenSnackbar} notification={notification} />
            <Loader backDrop open={load} />
        </>
    );
};
